import MapIcon from "@mui/icons-material/Map";
import { Button } from "@mui/material";
import type { Currency } from "@przezmorze/api-types";
import { useMemo, useState } from "react";
import { AddProductFromMapDialog } from "../../admin/products/map/AddProductFromMapDialog";
import type { ProductResponse } from "../../admin/products/productsApi";
import { useProducts } from "../../admin/products/useProducts";
import type { Product } from "../../sharedComponents/products/ProductSelect";
import ProductSelect from "../../sharedComponents/products/ProductSelect";
import { useAsyncDialog } from "../../sharedComponents/useAsyncDialog";

export type ProductFilterFn = (p: ProductResponse) => boolean;

const acceptAllFn = () => true;

export function ProductSelectAction(props: {
  placeholder?: string;
  filter?: ProductFilterFn;
  mapSelectionAvailable: boolean;
  onProductSelected(v: Product, date?: string): void;
  disabled?: boolean;
  currency?: Currency;
}) {
  const { products } = useProducts();
  const filter = props.filter ?? acceptAllFn;
  const filteredProducts = useMemo(
    () => products.filter(filter).filter((p) => !props.currency || p.currency == props.currency),
    [products, filter, props.currency],
  );
  const addFromMapDialog = useAsyncDialog<{ product: ProductResponse; date: string }>(({ onCancel, onAccept }) => (
    <AddProductFromMapDialog
      open={true}
      onClose={onCancel}
      onAddProduct={(product, date) => onAccept({ product, date: date! })}
      availableProducts={filteredProducts}
    />
  ));
  const [input, setInput] = useState("");
  async function handleAddFromMap() {
    const fromMap = await addFromMapDialog.open();
    if (!fromMap) return;
    props.onProductSelected(
      { id: fromMap.product.id, name: fromMap.product.name, provider: fromMap.product.provider } satisfies Product,
      fromMap.date,
    );
  }
  return (
    <>
      <ProductSelect
        fullWidth
        value={undefined}
        inputValue={input}
        onInputChange={(e, value, reason) => reason !== "reset" && setInput(value)}
        products={filteredProducts}
        placeholder={props.placeholder}
        disableClearable
        disabled={props.disabled}
        onChange={(_, product) => {
          setInput("");
          if (product) {
            props.onProductSelected(product);
          }
        }}
      />
      {props.mapSelectionAvailable && (
        <Button
          disabled={props.disabled}
          variant="outlined"
          color="primary"
          sx={{ py: 1.8, minWidth: "max-content", borderRadius: 2, textTransform: "none" }}
          startIcon={<MapIcon />}
          onClick={handleAddFromMap}
        >
          Wybierz z mapy
        </Button>
      )}
      {addFromMapDialog.portal}
    </>
  );
}
